import { Question } from '../../../../redux/test/type'

export const determineQuetionContent = (question: Question): any =>
  question?.questionContent || question?.question

export const isAnswerSelected = (
  question: Question,
  option: string
): boolean => {
  console.log(question?.answer);
  console.log('option', option); 
  
  return (
    question?.answer?.toLocaleLowerCase() === option ||
    question?.correctAnswer?.toLocaleLowerCase() === option
  )
}

export const isAnswerInCorrect = (
  question: Question,
  option: string
): boolean => {
  const isInCorrect =
    question?.submittedAnswered?.toLocaleLowerCase() !==
      question?.correctAnswer?.toLocaleLowerCase() &&
    question?.submittedAnswered?.toLocaleLowerCase() === option
  return isInCorrect
}
